module.exports = __webpack_public_path__ + "img/linkdin.20c3be1.svg";